import request from "@/api";

export function listGoodsGiftPack(data) {
    return request({
        url: '/api/goods/getGoodsGiftPackList',
        method: 'get',
        params: data
    })
}

export function listGoodsGiftPackChild(data) {
    return request({
        url: '/api/goods/getGoodsGiftPackChildList',
        method: 'get',
        params: data
    })
}

export function getGoodsGiftPackInfo(data) {
    return request({
        url: '/api/goods/getGoodsGiftPackInfo',
        method: 'get',
        params: data
    })
}

export function saveGoodsGiftPack(data) {
    return request({
        url: '/api/goods/saveGoodsGiftPack',
        method: 'post',
        data: data
    })
}


export function updateGoodsGiftPack(data) {
    return request({
        url: '/api/goods/updateGoodsGiftPack',
        method: 'post',
        data: data
    })
}

export function deleteGoodsGiftPack(data) {
    return request({
        url: '/api/goods/deleteGoodsGiftPack',
        method: 'post',
        data: data
    })
}

export function deleteGoodsGiftPackChild(data) {
    return request({
        url: '/api/goods/deleteGoodsGiftPackChild',
        method: 'post',
        data: data
    })
}

export function exportGoodsGiftPack(data) {
    return request({
        url: '/api/goods/exportGiftPack',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}

export function batchSaveGoodsGiftRemoveRecover(data) {
    return request({
        url: '/api/goods/batchSaveGoodsGiftRemoveRecover',
        method: 'post',
        data: data
    })
}